import { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { useIdleTimer } from 'react-idle-timer';

import moment from 'moment';

// Services
import CheckIfTimeIsWithinWorkHours from './hooks/CheckIfTimeIsWithinWorkHours';
import { getAuth, getAuthViaInterval, logOutUser } from './store/auth/auth.actions';
import { handleResetFormSteps } from './store/forms/forms.actions';



// Components

import Header from './components/Header/Header';

// Pages

import UserAccess from "./pages/UserAccess/UserAccess";
import AccountType from "./pages/AccountType/AccountType";
import UserProfile from "./pages/UserProfile/UserProfile";
// import MyAddresses from "./pages/UserProfile/MyAddresses";
// import MyReferences from "./pages/UserProfile/MyReferences";
// import MyJobs from "./pages/UserProfile/MyJobs";
// import MyRelations from "./pages/UserProfile/MyRelations";
// import MyCustomerPep from "./pages/UserProfile/MyCustomerPep";
// import ProductRequest from "./pages/UserProfile/ProductRequest/ProductRequest";
import DocumnentInfo from "./pages/DocumnentInfo/DocumnentInfo";
import Register from "./pages/Register/Register";
import UserInList from "./pages/UserInList/UserInList";
import UserIsRegistered from "./pages/UserIsRegistered/UserIsRegistered";
import Success from "./pages/Success/Success";
// import { setUpConsultClientData } from './utilities/helper-functions';


import OutsideWorkHours from "./pages/OutsideWorkHours/OutsideWorkHours";
import Loader from './components/UI/Loader/Loader';

function App() {
  // const [remaining, setRemaining] = useState(0);
  const { handleCheckIfTimeIsWithinWorkHours } = CheckIfTimeIsWithinWorkHours();
  const getAuthToken = useSelector((state) => state.auth.getAuth);
  const login = useSelector((state) => state.auth.login);
  const user = useSelector((state) => state.auth.user);
  const isWithinWorkHours = useSelector((state) => state.calendar.isWithinWorkHours);

  const dispatch = useDispatch();

  // Log out the user
  const handleUserLogOut = async () => {
    const data = {
        loginCliente: user.loginCliente,
        ntv: user.ntv,
    }
    dispatch(logOutUser(data));
  }


  // Log out or redirect the user to the homepage if idle

  const onIdle = () => {
    if (login.isLoggedIn) {
      handleUserLogOut();
    } else if (!login.isLoggedIn && window.location.pathname !== '/') {
      localStorage.removeItem("clientEmail");
      localStorage.removeItem('clientAge');
      dispatch(handleResetFormSteps());
      window.location.href = "/";
    }
  }

  const onActive = () => {}
  const onAction = () => {}

  const { getRemainingTime } = useIdleTimer({
    onIdle,
    onActive,
    onAction,
    timeout: login.isLoggedIn ? 300_000 : 900_000,
    throttle: 500
  })

  useEffect(() => {
    dispatch(getAuth());
    const interval = setInterval(() => {
      dispatch(getAuthViaInterval());
    }, 300000);

    return () => {
      clearInterval(interval)
    }
  }, []);


  // Compare the sessión date to the current date and log out the user if it has expired

  useEffect(() => {
    handleCheckIfTimeIsWithinWorkHours();
  }, []);

  return (
    <>

      {(getAuthToken?.isLoading || getAuthToken?.error) && (
        <Loader
          message={"Cargando..."}
          error={getAuthToken?.error}
          action={() => dispatch(getAuth())}
        />
      )}

      {(!getAuthToken?.isLoading && getAuthToken?.data) &&        
        <Router>
          <Header />

          {/* {!login.isLoggedIn && */}
          <Routes>
            {isWithinWorkHours === true ? (
              <>
                <Route path="/" element={<UserAccess />} />
                <Route path="/infodedocumento" element={<DocumnentInfo />} />
                <Route path="/tipocuenta" element={<AccountType />} />
                <Route path="/registro" element={<Register />} />
                <Route path="/success" element={<Success />} />
                <Route path="/usuarioregistrado" element={<UserIsRegistered />} />
                <Route path="/solicitud" element={<UserInList />} />
                <Route path="*" element={<Navigate to ="/" />}/>
              </>
            ) : (
              <>
                <Route path="/" element={<OutsideWorkHours />} />
                <Route path="*" element={<Navigate to ="/" />}/>
              </>
            )}
          </Routes>
          {/* } */}

          {/* {login.isLoggedIn &&
          <Routes>
            {isWithinWorkHours === true ? (
              <>
                {["/", "/miperfil"].map(path => (
                  <Route
                    key={path}
                    path={path}
                    element={<UserProfile />}
                  />
                ))}
                <Route path="/miperfil/solicitud_producto" element={<ProductRequest />} />
                <Route path="*" element={<Navigate to ="/" />}/>
              </>
            ) : (
              <>
                <Route path="/" element={<OutsideWorkHours />} />
                <Route path="*" element={<Navigate to ="/" />}/>
              </>
            )}
          </Routes>} */}
        </Router>}
    </>
  );
}

export default App;
